import { BluetoothConnectIcon } from './BluetoothConnectIcon';

/**
 * author: Google
 * id 1E123F41-EA93-4085-8446-88F50C501A6F
 * name bluetooth-connect
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bluetooth-connect.svg
 * tags
 */
export const BluetoothConnectedIcon = BluetoothConnectIcon;
export default BluetoothConnectedIcon